/**订单状态enum */
export const ORDER_STATUS = {
  all: 0,
  waitPay: 1, // 待支付
  tobeUsed: 2, // 待使用
  notTransacted: 3, // 未成交
  completed: 4 // 已完成
};

/**订单状态enum */
export const ORDER_STATUS_NAME = {
  1: '待付款',//待支付
  2: '待使用',//待使用
  3: '未成交',//未成交
  4: '已完成',//已完成
}

/**支付状态enum */
export const PAYMENT_STATUS = {
  unpaid: 1,//未支付
  paid: 2,//已支付
  fail: 3,//支付失败
}

/**预约状态enum */
export const APPOINTMENT_STATUS = {
  success: 1,//预约成功
  fail: 2,//预约失败
  confirming: 3,//预约确认中
}
/**订单状态enum */
export const APPOINTMENT_STATUS_NAME = {
  1: { name: '预约成功', tip: '您已成功预约餐厅， 请按照日期时间前往就餐' },//待支付
  2: { name: '预约失败', tip: '' },//待使用
  3: { name: '预约确认中', tip: '预约成功后，我们将向您预留的手机号 发送短信通知，请注意查收' },//未成交
}

/**退款押金状态enum */
export const REFOUND_DEPOSIT_STATUS= {
  init : 0,//初始
  refunding :1,//退款中
  success :2,//退款成功
  fail : 3,//退款失败
}
/**退款押金状态enum */
export const REFOUND_DEPOSIT_STATUS_NAME = {
  0: { name: '', tip: '' },
  1: { name: '押金退款中', tip: '您已申请退款，后台审核需1-3天，请耐心等候' },
  2: { name: '押金退款成功', tip: '扣除预约费，套餐押金已退还至您的账户' },
  3: { name: '押金退款失败', tip: '' },
}
/**退款全款状态enum */
export const REFOUND_AMOUNT_STATUS = {
  init: 0,//初始
  refunding: 1,//退款中
  success: 2,//退款成功
  fail: 3,//退款失败
}

/**退款全额状态enum */
export const REFOUND_AMOUNT_STATUS_NAME = {
  1: { name: '退款中', tip: '抱歉您所期望的时间段已约满，请预约其他时间' },
  2: { name: '退款成功', tip: '餐厅押金、预约费已退还至您的账户' },
  3: { name: '拒绝退款', tip: '' },
}

/**好位订单状态enum */
export const GOOD_ORDER_STATUS ={
  paying : 1,//支付中
  in_the_draw :2,//抽奖中
  tobeUsed : 3,//待使用
  cancel : 4,//已取消
  not_winning : 6,//未中奖
  refounding :7,//押金退款中
  refound_fail : 8,//退款失败
  refound_success:9,//退款成功
}
/**好位订单状态enum */
export const GOOD_ORDER_STATUS_NAME= {
  1: { name: '待付款', tip: '' },
  2: { name: '抽奖中', tip: '等待开奖中，请时刻关注中奖信息' },
  3: { name: '待使用', tip: '您已成功预约餐厅， 请按照日期时间前往就餐' },
  4: { name: '已取消', tip: '您已取消订单' },
  6: { name: '未中奖', tip: '本次未抽中餐厅座位，感谢您的参与' },
  7: { name: '押金退款中', tip: '我们会在1-3个工作日审核完成，请耐心等待' },
  8: { name: '押金退款失败', tip: '' },
  9: { name: '押金退款成功', tip: '扣除预约费，套餐押金已退还至您的账户' },
}
/**默认头像 */
export const defaultAvatar =
  "https://seastart-dev.oss-cn-hangzhou.aliyuncs.com/4/1712479973828.png";


